<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ title }}</h2>
    </header>
    <article class="view__content">
      <div class="view__panel">
        <div class="form js-form">
          <submenu v-if="this.$route.params.id"></submenu>
          <div class="blocks-list">
            <draggable v-model="properties" :options="{handle:'.blocks-list__action--move'}">
                <transition-group>
                    <div class="blocks-list__item" v-for="(item, index) in properties" v-bind:key="index">
                        <div class="blocks-list__info">
                          <p class="blocks-list__title">
                            {{ item.label }}
                          </p>
                          <p class="blocks-list__type">{{ item.control }}</p>
                          <div class="blocks-list__actions">
                            <a class="blocks-list__action" href="javascript: void(0)" data-acc="collapse-field" v-on:click="toggle(index)">
                              <i class="icon icon--arrowd" v-if="!item.shown"></i>
                              <i class="icon icon--arrowu" v-else></i>
                            </a>
                            <a class="blocks-list__action" href="javascript: void(0)" data-acc="delete-field" v-if="!item.isDefault" v-on:click="remove(index)">
                              <i class="icon icon--delete"></i>
                            </a>
                            <a class="blocks-list__action blocks-list__action--move" href="javascript: void(0)">
                              <i class="icon icon--move"></i>
                            </a>
                          </div>
                        </div>
                        <div class="blocks-list__control" v-if="item.shown">
                          <input v-model="item.isDefault" type="hidden" />
                          <span v-if="item.sharedGroups != null && item.sharedGroups.length">
                            {{ L.localize('Settings_Group_CustomFields_AlsoInGroup') + item.sharedGroups.join(', ') }}
                          </span>
                          <div class="form__input-container" v-if="!item.isDefault">
                            <fieldset class="form__field">
                              <label class="form__label">
                                {{ L.localize("Settings_Group_CustomFields_Name")}}
                              </label>

                              <v-autocomplete
                                :items="groupsSource"
                                v-model="item.title"
                                :auto-select-one-item="false"
                                :get-label="getLabel"
                                :component-item='template'
                                data-acc="name"

                                @item-clicked="mapProperties(item)"
                                @change="lookup($event, item)"
                                @update-items="updateItems"></v-autocomplete>
                            </fieldset>
                          </div>


                          <TextBox label="Settings_Group_CustomFields_Name" v-model="item.title" v-if="item.isDefault" :disabled="item.isDefault" @input="lookup($event, item)"  />

                          <TextBox label="Settings_Group_CustomFields_Label" v-model="item.label" />

                          <SelectList label="Settings_Group_CustomFields_Type" v-model="item.control" :options="dataTypes" />

                          <TextBox label="Settings_Group_CustomFields_Regex" v-model="item.regexValidator" v-if="isTextFieldType(item)" />

                          <CheckBox v-model="item.required" label="Settings_Group_CustomFields_Required" :disabled="item.isDefault" />

                          <CheckBox v-model="item.displayInGrid" label="Settings_Group_CustomFields_DisplayInGrid" />

                          <CheckBox v-model="item.adminOnly" label="Settings_Group_CustomFields_AdminOnly" :disabled="item.isDefault" />

                          <CheckBox v-model="item.isAutomaticNumbering"
                                    label="Settings_Group_CustomFields_IsAutomaticNumbering"
                                    tooltip="Settings_Group_CustomFields_IsAutomaticNumberingTooltip"
                                    v-if="isTextFieldType(item)"
                                    :disabled="item.isDefault" />

                          <fieldset class="form__field" v-if="showOptionsLabel(item)">
                            <label class="form__label" for="adminOnly">Options</label>
                            <ul class="light-crud-list">
                              <draggable v-model="item.optionsLabels" :options="{handle:'.light-crud-list__button-row--move'}">
                                  <template v-for="(option, optionIndex) in item.optionsLabels">
                                      <li class="light-crud-list__row" >
                                          <div class="light-crud-list__input-row">
                                            <input v-model="item.optionsLabels[optionIndex]" class="form__input" type="text">
                                          </div>
                                          <div class="light-crud-list__button-row">
                                              <a href="javascript: void(0)" v-on:click="removeOptionRow(index, optionIndex)">
                                              {{ L.localize('Label_Delete') }}
                                                <i class="icon icon--minus"></i>
                                              </a>
                                              <a class="light-crud-list__button-row--move" href="javascript: void(0)">
                                                <i class="icon icon--move"></i>
                                              </a>
                                          </div>
                                      </li>
                                  </template>
                              </draggable>
                              <tfoot>
                                <li>
                                    <div class="light-crud-list__add-row" colspan="2">
                                      <a href="javascript: void(0)" v-on:click="addOptionRow(index)">
                                        {{ L.localize('Label_Add') }}
                                        <i class="icon icon--plus"></i>
                                      </a>
                                    </div>
                                </li>
                            </tfoot>
                            </ul>
                          </fieldset>
                        </div>
                    </div>
                </transition-group>
            </draggable>
          </div>

          <Btn v-on:click="save" label="Label_SaveButton" />
          <Btn v-on:click="$router.push({name: 'groups'})" label="Label_CancelButton" :withBorder="true" />
          <Btn v-on:click="add" label="Label_Add" :withBorder="true" float="right" />
        </div>
      </div>
    </article>

  </article>
</template>

<script>
import CustomFieldAutoCompleteTemplate from './CustomFieldAutoCompleteTemplate.vue'
import { TextBox, Btn, CheckBox, SelectList } from 'components/layout/forms'
import Submenu from 'components/views/groups/Submenu'
import L from 'services/Localization'
import { mapGetters } from 'vuex'
import notifications from 'mixins/notifications'
import draggable from 'vuedraggable'
import _ from 'lodash'
import Util from 'services/Util'

export default {
  name: 'group-custom-fields',
  components: { Submenu, draggable, TextBox, Btn, CheckBox, SelectList },
  mixins: [notifications],
  data() {
    return {
      loading: false,
      L: L,
      properties: [],
      services: {
        group: window.abp.services.app.group
      },
      groupItem: {},
      groupsSource: [],
      template: CustomFieldAutoCompleteTemplate
    }
  },
  beforeCreate() {
    this.$store.dispatch('getDataTypes')
    this.$store.dispatch('getGroup', this.$route.params.id).then(() => {
      this.mapFromState()
    })
  },
  computed: {
    ...mapGetters({
      group: 'activeGroup',
      dataTypes: 'allDataTypes'
    }),
    title() {
      return this.group.name
    }
  },
  methods: {
    // autocomplete
    getLabel (item) {
      return item
    },
    updateItems (text) {
      this.services.group.getAllProperties(text).then((response) => {
        this.groupsSource = response.map((item) => {
          return item.title
        })
      })
    },
    mapProperties(item) {
      let properties = this.properties
      this.services.group.getPropertyByTitle(item.title).then((response) => {
        var index = _.findIndex(properties, { title: item.title })
        _.assign(this.properties[index], response);
        this.checkForSharedProperty(item.title, item)
      })
    },
    toggle(index) {
      this.$set(this.properties[index], 'shown', !this.properties[index].shown)
    },
    checkForSharedProperty(title, item) {
      item.title = Util.toId(title)
      let properties = this.properties
      this.services.group.isSharedProperty(this.group.id, title).done(function (result) {
        var index = _.findIndex(properties, { title: title })
        if (properties[index]) {
          properties[index].sharedGroups = result
        }
      })
    },
    lookup: _.debounce(function (event, item) {
      this.checkForSharedProperty(event, item)
    }, 300),
    mapFromState() {
      this.properties = _.cloneDeep(this.group.properties)
    },
    showOptionsLabel: function (item) {
      return item.control === 'radio' ||
        item.control === 'select' ||
        item.control === 'checkbox'
    },
    isTextFieldType: function (item) {
      return item.control === 'text'
    },
    removeOptionRow: function (index, option) {
      this.properties[index].optionsLabels.splice(option, 1)
    },
    addOptionRow: function (index) {
      if (this.properties[index].optionsLabels == null) {
        this.properties[index].optionsLabels = ['']
      } else {
        this.properties[index].optionsLabels.push('')
      }
    },
    remove: function (index) {
      this.properties.splice(index, 1)
    },
    add: function () {
      this.properties.push({
        title: 'new_property',
        label: 'New property',
        control: 'text',
        required: true,
        displayInGrid: true,
        optionsLabels: null,
        sharedGroups: null,
        adminOnly: false,
        isDefault: false,
        isAutomaticNumbering: false,
        shown: true
      })
    },
    save() {
      this.properties.forEach(function (entry) {
        entry.enum = entry.optionsLabels
      })
      let updatedGroup = _.cloneDeep(this.group)
      updatedGroup.properties = this.properties
      this.$store.dispatch('createOrUpdateGroup', updatedGroup).then(() => {
        this.mapFromState()
        this.showNotification({
          title: L.localize('Label_SuccessEdit'),
          message: L.localize('Label_Success')
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// GroupCustomFields.vue?680cb2e7